// Importe les composants nécessaires de react-router-dom
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// Importe le layout principal
import MainLayout from './layouts/MainLayout';
import AppContent from './AppContent';
// Importe les pages
import LoginPage from './pages/auth/Login'; // Page de connexion

import { AuthProvider, useAuth } from './contexts/AuthContext'; // Importe le AuthProvider (à créer)
import { IdentificationProvider } from './contexts/IdentificationContext'; // Importe le IdentificationProvider
import RegisterPage from './pages/auth/Register';
import OTP from './pages/auth/OTP'
import ForgetPassword from './pages/auth/ForgetPassword'
import DefinePassword from './pages/auth/DefinePassword'




// Composant de route protégée
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  // Si non authentifié, redirige vers la page de connexion
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  // Si authentifié, rend les enfants de la route
  return children;
};

const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  // Si authentifié, redirige vers la page d'accueil
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return children;
};


// Composant principal de l'application
function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path='/login' element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
          /> {/* Page de connexion */}
          <Route path='/register' element={
            <PublicRoute>
              <RegisterPage />
            </PublicRoute>
          }
          /> {/* Page d'inscription */}
          <Route path='/otp' element={
            <PublicRoute>
              <OTP />
            </PublicRoute>
          } />
          <Route path='/forget-password' element={
            <PublicRoute>
              <ForgetPassword />
            </PublicRoute>
          } />
          <Route path='/define-password' element={
            <PublicRoute>
              <DefinePassword />
            </PublicRoute>
          } />
          <Route path='/*' element={<ProtectedRoute>
            <IdentificationProvider>
              <MainLayout>
                <AppContent />
              </MainLayout>
            </IdentificationProvider>
          </ProtectedRoute>} />
        </Routes>
      </Router>
    </AuthProvider >
  );
}

export default App;
